import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(ElementUI);
Vue.config.devtools = true;

import Index from '@/views/Index';
import Test from '@/views/Test';
import Win from "@/views/Win.vue";
import Max from "@/views/Max.vue";

let router = new VueRouter({
  mode: 'history', routes: [{
    path: '/', component: Index, meta: {
      title: 'Anymo官网-背单词、考研、高考的提分神器', content: {
        keywords: '无学科之分，万能的学习助手',
        description: '不管你想学英语、日语、德语……还是法律、数学、语文、医学…我都能完美胜任，因为我是如纸笔一样的基础学习工具和一套领先于时代的学习方法的结合体，值得你终身使用的'
      }, KeepAlive: false
    },
  }, {
    path: '/download', component: Index, meta: {
      title: 'Anymo', content: {keywords: '', description: ''}, KeepAlive: false
    },
  }, {
    path: '/max', name: 'max', component: Max, meta: {
      title: 'Anymo', content: {keywords: '', description: ''}, KeepAlive: false
    },
  }, {
    path: '/win', name: 'win', component: Win, meta: {
      title: 'Anymo', content: {keywords: '', description: ''}, KeepAlive: false
    },
  }, {
    path: '/test', component: Test, meta: {
      title: 'Anymo', content: {keywords: '', description: ''}, KeepAlive: false
    },
  }]
})

Vue.config.productionTip = false

new Vue({
  router, render: h => h(App), mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app');

